/**
 * @generated SignedSource<<33408eae88e7db587f4be645fb4e26e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type StartContentConfigType = "StartContent_CanAfterStartingTree" | "StartContent_CanIfCertificationUnlocked" | "StartContent_CanIfInTreeFlow" | "StartContent_CanIfUnlocked" | "StartContent_CanNDaysAfterStartingTree" | "StartContent_CanNot";
import { FragmentRefs } from "relay-runtime";
export type startContentConfigEditor_TreeNodeFragment$data = {
  readonly id: string;
  readonly typeDefinition: {
    readonly startConfigs?: ReadonlyArray<{
      readonly configType: StartContentConfigType;
      readonly days?: number;
      readonly id: string;
    }>;
  };
  readonly " $fragmentType": "startContentConfigEditor_TreeNodeFragment";
};
export type startContentConfigEditor_TreeNodeFragment$key = {
  readonly " $data"?: startContentConfigEditor_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"startContentConfigEditor_TreeNodeFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "startContentConfigEditor_TreeNodeFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "typeDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "startConfigs",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "configType",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "days",
                      "storageKey": null
                    }
                  ],
                  "type": "CanNDaysAfterStartingTreeStartContentConfig",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "ELearningContentTypeDefinition",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TreeNode",
  "abstractKey": null
};
})();

(node as any).hash = "736aa59badc4a1d737497c90ecfbef02";

export default node;
